import { getToken } from "../Auth";
import { ConfigStore, connectionStore, ConnectionNames } from "../Stores";
import { connectWithSubscriptions } from "../Network";
export function connectSportsWithToken() {
    return getToken()
        .then(token => {
        // code available only in debug builds is excluded from coverage
        /* istanbul ignore next */
        if (process.env.NODE_ENV === "development") {
            window["__token__"] = token;
        }
        const connConfig = ConfigStore.config.urls[ConnectionNames.sports];
        if (connConfig) {
            connConfig.queryParams.jwt = token;
        }
        const sportConnection = connectionStore.get(ConnectionNames.sports);
        if (sportConnection) {
            sportConnection.updateToken(token);
            connectWithSubscriptions(sportConnection, ConfigStore.config.urls[ConnectionNames.sports]).catch(console.error);
        }
        return token;
    })
        .catch(console.error);
}
//# sourceMappingURL=connectSportsWithToken.js.map